export default "__VITE_ASSET__3XpMv1I___"